
import { getAnonymousId, pushAnalyticsObjToDataLayer, shaEncrypt } from "@/utils/helper"

export const getAnalyticsData = (type, url, needsJSON = false) => {
  const title = type.toLowerCase().trim()
  let eventAction
  let internalLinkZoneName
  let internalLinkURL
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  if (title === "notify me") {
    internalLinkZoneName = `${page?.category?.pageType}:modal:availability notification`
    eventAction = `${internalLinkZoneName}:${title}`
  } else if (title === "local store or showroom") {
    eventAction = `${page?.category?.pageType}:product details:add-on services:${title}`
    internalLinkURL = `${url.toLowerCase().trim()}`
  } else if (title === "where to buy") {
    internalLinkURL = `${window.location.origin + url}`
  }
  const eventInfo = {
    eventAction:
      eventAction || `${page?.category?.pageType}:product details:${title}`,
    eventName:
      eventAction || `${page?.category?.pageType}:product details:${title}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${title}`,
    internalLinkPosition: `${page?.category?.pageType}`,
    internalLinkType: `${page?.category?.pageType}:${title}`,
    internalLinkZoneName:
      internalLinkZoneName || `${page?.category?.pageType}:product details`,
    internalLinkURL: internalLinkURL || "n/a",
    clickInternalLinks: "true",
  }
  if (needsJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const replaceAddToCartDatalayerPush = (
  replaceAddToCartCtaLabel,
  replaceAddToCartCtaLink,
  analyticData
) => {
  const eventInfo = getAnalyticsData(
    replaceAddToCartCtaLabel,
    replaceAddToCartCtaLink,
    true
  )
  const page = window.adobeDataLayer.getState("page")
  analyticData = JSON.parse(analyticData)
  const productInfo = analyticData?.productInfo
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    productInfo,
    page,
  })
}

export const addToCompareAnalytics = isChecked =>
  `{"eventAction":"pdp:product details: ${
    isChecked ? "remove" : "add to"
  } compare","eventName":"pdp:product details: ${
    isChecked ? "remove" : "add to"
  } compare","eventType":"n/a","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"${
    isChecked ? "remove" : "add to"
  } compare","internalLinkPosition":"pdp","internalLinkType":"pdp:${
    isChecked ? "remove" : "add to"
  } compare","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}`

export const quantityOutOfStockAnalytics = (productInfo, pincode) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "pdp:product details:check availability",
    eventName: "pdp:product details:check availability",
    eventType: "navigation",
    internalLinkName: "check availability",
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:${pincode}`,
    internalLinkZoneName: "pdp:product details",
    internalLinkURL: "n/a",
  }
  const outOfStockInfo = {
    availability: "out_of_stock",
    errorMessage:
      "This product is currently unavailable. Please check back later.",
    productStatus: "out of stock",
    pincode: pincode,
  }
  productInfo = { ...productInfo, ...outOfStockInfo }
  const customDataLayer = { productInfo }
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click", {}, customDataLayer)
}

const generateEventId=() =>{
  return `${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

export const gtmAddToCartEvent = async ({productInfo, utmPayload})=>{
  const {utm_source="", utm_medium=""} = utmPayload || {}
  const {productSalePrice="",category="", quantity="", productName="", productID="" } = productInfo || {}
  const eventId=generateEventId()
  window.dataLayer.push({
    "event": "add_to_cart",
    "event_id": eventId,
    "source":utm_source,
    "medium":utm_medium,
    "ecommerce": {
      "currency": "INR",
      "value": productSalePrice,
      "items": [
        {
          "item_id": productID,
          "item_name": productName,
          "item_category": category,
          "quantity": quantity
        }
      ]
    }
  })
  const eventTime = Math.floor(Date.now() / 1000);
  const anonymousId = getAnonymousId()
  const oktaToken = localStorage.getItem("okta-token-storage")
  let emailId=""
  if (oktaToken && oktaToken !== "{}") {
    const oktaObject = JSON.parse(oktaToken)
    const claim = oktaObject?.accessToken?.claims || {}
    emailId=claim?.sub
  }
  await fetch(
    `https://graph.facebook.com/v25.0/${process.env.NEXT_PUBLIC_META_PIXEL_ID}/events?access_token=${process.env.NEXT_PUBLIC_META_ACCESS_TOKEN}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: [
          {
            event_name: 'AddToCart',
            event_time: eventTime,
            event_id: eventId,
            action_source: 'website',
           "user_data": { 
            "client_user_agent": navigator.userAgent,
            ...(emailId!=="" && {em: [await shaEncrypt(emailId.toLowerCase())]}),
            ...(anonymousId !== "" && { external_id: anonymousId }),

         },
            custom_data: {
              value: productSalePrice,
              currency: 'INR',
              content_ids: [productID],
              contents: [
                {
                  id: productID,
                  quantity: quantity,
                },
              ],
            },
          },
        ],
      }),
    }
  );
}
